import { useTranslation } from 'react-i18next';
import { useErrors } from 'pages/SmartConnectors/SmartConnector/hooks/useErrors';
import { FC } from 'react';
import type {
  GenericOption,
  SmartConnectorActivityField,
} from 'pages/SmartConnectors/types';
import MultiSelect from '__components/Inputs/MultiSelect';
import { getDataQAForInput } from '__components/Inputs/helpers';
import { useActivityFieldsQuery } from 'queries/models/activities-ts';

export const ActivityFieldsSelect: FC<{
  activityObjectId?: string;
  value?: SmartConnectorActivityField[];
  onChange: (value: SmartConnectorActivityField[]) => void;
}> = ({ activityObjectId, value, onChange }) => {
  const { t } = useTranslation();

  const { data: activityFieldOptions = [], isLoading } = useActivityFieldsQuery(
    activityObjectId!,
    {
      enabled: !!activityObjectId,
      select: (fields) =>
        fields.map((field) => ({
          value: field.id,
          label: field.display_name,
          data: field,
        })),
      staleTime: 0,
    }
  );

  const { clearError, validate, error } = useErrors('activity_fields');

  const handleChange = (
    value: (GenericOption & { data: SmartConnectorActivityField })[]
  ) => {
    onChange(
      value.map(
        (item) => item.data //item.data
      )
    );
    clearError();
  };

  return (
    <MultiSelect
      label={t('Choose Input Fields')}
      placeholder={t('Find Fields')}
      value={
        value?.map((field) => ({
          value: field.id,
          label: field.display_name,
          data: field,
        })) || []
      }
      onChange={handleChange}
      options={activityFieldOptions}
      isLoading={isLoading}
      margin
      error={error}
      validate={validate}
      {...getDataQAForInput('smart-connector-activity-fields', 'dropdown')}
    />
  );
};
